import { useEffect } from 'react';
import helmet from 'helmet';

export default function ChatBot() {

  useEffect(() => {
    // 1. Create the script element
    //const script = document.createElement('script');
    //script.src = "https://twitter.com"; // Replace with your script URL
    //script.async = true;
    
    // 2. Append the script to the body
    //document.body.appendChild(script);

    // Clean up the script when the component unmounts
    //return () => {
      //document.body.removeChild(script);
    //};
  }, []);

  return (
    // The target element that your third-party script looks for
      <div className="twitter-share-button-container">
      <script 
        crossOrigin='anonymous' 
        src="https://widgets.leadconnectorhq.com/loader.js" 
        data-resources-url="https://widgets.leadconnectorhq.com/chat-widget/loader.js" 
        data-widget-id="6a2b98a2bd8129997d06a85f">

      </script>
    </div>
  );
}